import { createSelector } from 'reselect';
import {
  getMerchant,
  getMerchantError,
  preAssessmentDetails,
  getQuestionnaires,
  merchantRegion,
  getMappedCountryConfig,
} from '@/selectors/merchant';
import { getFrontendTypeFromQueryParam, isWidget, isUnmanagedKyc } from '@/selectors/widget';
import { getAllFeatures } from '@/selectors/featuresConfig';
import { router } from './router';

export const getFlowConfig = createSelector(
  getMerchant,
  getMerchantError,
  preAssessmentDetails,
  isWidget,
  isUnmanagedKyc,
  getAllFeatures,
  getFrontendTypeFromQueryParam,
  merchantRegion,
  getQuestionnaires,
  getMappedCountryConfig,
  (
    merchant,
    merchantError,
    preAssessmentDetails,
    isWidget,
    isUnmanagedKyc,
    features,
    widgetType,
    region,
    questionnaires,
    merchantCountryConfig,
  ) => {
    return router({
      merchant,
      merchantError,
      preAssessmentDetails,
      isWidget,
      isUnmanagedKyc,
      features,
      widgetType,
      region,
      questionnaires,
      merchantCountryConfig,
    });
  },
);
